export const baseURL = 'https://api.rumcasozluk.com'
